import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { homeComponent } from './home/home.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { CadastroComponent } from './cadastro/cadastro.component';
import { RouterModule } from '@angular/router';
import { NgxMaskModule } from 'ngx-mask';
import { AdministraComponent } from './administra/administra.component';
import { AnaliseComponent } from './analise/analise.component';
import { ComunicacaoComponent } from './comunicacao/comunicacao.component';
import { UploadComponent } from './upload/upload.component';
import { RevisaoComponent } from './revisao/revisao.component';
import { UploadrevisaoComponent } from './uploadrevisao/uploadrevisao.component';
import { AcessoComponent } from './acesso/acesso.component';
import { MenuComponent } from './menu/menu.component';
import { AlterarComponent } from './alterar/alterar.component';
import { ExcluirComponent } from './excluir/excluir.component';
import { IncluirComponent } from './incluir/incluir.component';
import { InscricaoComponent } from './inscricao/inscricao.component';





@NgModule({
  declarations: [homeComponent, CadastroComponent, AdministraComponent, AnaliseComponent, ComunicacaoComponent, UploadComponent, RevisaoComponent, UploadrevisaoComponent, AcessoComponent, MenuComponent, AlterarComponent, ExcluirComponent, IncluirComponent, InscricaoComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SharedModule,
    HttpClientModule,
    RouterModule,
    NgxMaskModule.forChild()
  ],
  exports: [homeComponent]
})
export class ViewsModule { }
